angular.module('app.filters').filter('getById', () => {
  'ngInject';
  return (map, searchValue, keyField = 'id', displayField = null, defaultValue = null) => {
    let result = _.find(map, (item) => item[keyField] == searchValue);
    if (displayField) {
      return _.get(result, displayField, defaultValue);
    } else {
      return result;
    }
  };
});



// WEBPACK FOOTER //
// ./app/filters/get-by-id.js